module.exports = __webpack_public_path__ + "../resources/img/ic_re_lt_ef_layer_set_2_offgrid_img.be603ebc.svg";